/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return AiFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<AiFeatureFlagsWithDefaults>): AiFeatureFlagsWithDefaults {
        let obj = Object.assign(new AiFeatureFlagsWithDefaults(), model);
        AiFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiFeatureFlagsWithDefaults>): AiFeatureFlagsWithDefaults {
        if (!model) return null;
        return AiFeatureFlagsWithDefaults.newInstance(<AiFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.AiFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    ai_2504_b_master_data_sync: boolean = false;

    /**
     * Flag's default value
     */
    ai_2602_b_release_impact_analysis: boolean = false;

}
